import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Nav from "./components/Shared/Nav/Nav";
import Home from "./components/Home/Home/Home";
import AllProducts from "./components/AllProducts/AllProducts";
import Login from "./components/Login/Login";
import SignUp from "./components/SignUp/SignUp";
import NotFound from "./components/Not Found/NotFound";
import AuthProvider from "./contexts/AuthProvider";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import ProductDetails from "./components/ProductDetails/ProductDetails";
import AddNewProduct from "./components/AddNewProduct/AddNewProduct";
import MyOrders from "./components/MyOrders/MyOrders";
import ManageAllOrders from "./components/ManageAllOrders/ManageAllOrders";
import ManageProducts from "./components/ManageProducts/ManageProducts";
import MakeAdmin from "./components/MakeAdmin/MakeAdmin";
import Pay from "./components/Pay/Pay";
import AddReview from "./components/AddReview/AddReview";

function App() {
  return (
    <div>
      <AuthProvider>
        <Router>
          <Nav></Nav>
          <Switch>
            <Route exact path="/">
              <Home></Home>
            </Route>
            <Route exact path="/home">
              <Home></Home>
            </Route>
            <Route exact path="/products">
              <AllProducts></AllProducts>
            </Route>
            <PrivateRoute exact path="/products/:id">
              <ProductDetails></ProductDetails>
            </PrivateRoute>
            <PrivateRoute exact path="/myOrders">
              <MyOrders></MyOrders>
            </PrivateRoute>
            <PrivateRoute exact path="/manageAll">
              <ManageAllOrders></ManageAllOrders>
            </PrivateRoute>
            <PrivateRoute exact path="/addNew">
              <AddNewProduct></AddNewProduct>
            </PrivateRoute>
            <PrivateRoute exact path="/manageProducts">
              <ManageProducts></ManageProducts>
            </PrivateRoute>
            <PrivateRoute exact path="/makeAdmin">
              <MakeAdmin></MakeAdmin>
            </PrivateRoute>
            <PrivateRoute exact path="/pay">
              <Pay></Pay>
            </PrivateRoute>
            <PrivateRoute exact path="/addReview">
              <AddReview></AddReview>
            </PrivateRoute>

            <Route exact path="/login">
              <Login></Login>
            </Route>
            <Route exact path="/signup">
              <SignUp></SignUp>
            </Route>

            <Route path="*">
              <NotFound></NotFound>
            </Route>
          </Switch>
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
